import { render, staticRenderFns } from "./topHeadeg.vue?vue&type=template&id=36126ebe&scoped=true&"
import script from "./topHeadeg.vue?vue&type=script&lang=js&"
export * from "./topHeadeg.vue?vue&type=script&lang=js&"
import style0 from "./topHeadeg.vue?vue&type=style&index=0&id=36126ebe&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36126ebe",
  null
  
)

export default component.exports